import React from 'react'
import { BsTwitter, BsInstagram, BsLinkedin, BsGithub, BsTiktok } from "react-icons/bs"
import { FaFacebook } from "react-icons/fa"

const SocialMedia = () => {
  const openLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='app__social'>
      <div>
        <BsLinkedin 
          onClick={() => openLink("https://www.linkedin.com/in/ayuscal-sedhai-b9ba87280")} 
          style={{ cursor: "pointer" }} 
          aria-label="LinkedIn"
        />
      </div>
      <div>
        <BsGithub 
          onClick={() => openLink("https://github.com/Ayuscal")} 
          style={{ cursor: "pointer" }}
          aria-label="GitHub"
        />
      </div>
      <div>
        <BsTwitter 
          onClick={() => openLink("https://x.com/ayuscal")} 
          style={{ cursor: "pointer" }}
          aria-label="Twitter"
        />
      </div>
      <div>
        <FaFacebook 
          onClick={() => openLink("https://www.facebook.com/ayuscal.sedhai")} 
          style={{ cursor: "pointer" }}
          aria-label="Facebook"
        />
      </div>
      <div>
        <BsInstagram 
          onClick={() => openLink("https://www.instagram.com/ayuscal")} 
          style={{ cursor: "pointer" }}
          aria-label="Instagram"
        />
      </div>
      <div>
        <BsTiktok 
          onClick={() => openLink("https://www.tiktok.com/@ayuscalsedhai0")} 
          style={{ cursor: "pointer" }}
          aria-label="TikTok"
        />
      </div>
    </div>
  )
}

export default SocialMedia